import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconView(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3C19.55 3 20.0204 3.19622 20.4121 3.58789C20.8038 3.97956 21 4.45 21 5V19C21 19.55 20.8038 20.0204 20.4121 20.4121C20.0204 20.8038 19.55 21 19 21H5C4.45 21 3.97956 20.8038 3.58789 20.4121C3.19622 20.0204 3 19.55 3 19L3 5C3 4.45 3.19622 3.97956 3.58789 3.58789C3.97956 3.19622 4.45 3 5 3L19 3ZM5 19H9V15H5V19ZM11 19H19V15H11V19ZM5 10V13H19V10H5ZM5 8L19 8V5L5 5V8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
